import { applyMiddleware, legacy_createStore as createStore } from "redux";
import rootReducer from "./Reducer";
// import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./Sagas";

const sagaMiddleware = createSagaMiddleware();

// const logger = createLogger({
//   collapsed: false,
// });

const store = createStore(
  rootReducer,
  undefined,
  applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);

export default store;
